export default __webpack_public_path__ + "static/media/r3dent_big.b3fc8d69.svg";